import { Link } from "react-router-dom";

// Placeholder legal pages. The seller facts are real; the rest is a template
// the owner must review with an accountant or lawyer before the store is live.
const SELLER = "Prodejce: Hubert Doubek, IČO 21908176, se sídlem Masarykova 582/58, 289 22 Lysá nad Labem. Nejsem plátce DPH.";

const PAGES = {
  terms: {
    title: "Obchodní podmínky",
    body: [
      "Tyto obchodní podmínky upravují nákup zboží v e-shopu The Creaks na adrese thecreaksofficial.com/merch.",
      SELLER,
      "Zboží a ceny. Fotky zboží jsou ilustrační. Ceny jsou uvedeny včetně DPH, pokud se DPH uplatňuje. Konečná cena se zobrazí v košíku před odesláním objednávky.",
      "Objednávka. Objednávka vzniká odesláním košíku a je závazná po zaplacení. Potvrzení objednávky obdržíte e-mailem.",
      "Platba. Platba kartou přes SumUp nebo bankovním převodem přes QR kód. V zahraničí pouze kartou.",
      "Doprava. Doručení přes Zásilkovnu na výdejní místo nebo na adresu. Dodací lhůtu a cenu dopravy vidíte před dokončením objednávky.",
      "Odstoupení od smlouvy. Spotřebitel může do 14 dnů od převzetí zboží odstoupit bez udání důvodu. Podrobnosti ve formuláři pro odstoupení.",
      "Reklamace. Práva z vadného plnění se řídí reklamačním řádem.",
      "Mimosoudní řešení sporů. Spotřebitel se může obrátit na Českou obchodní inspekci (www.coi.cz).",
    ],
  },
  returns: {
    title: "Reklamační řád",
    body: [
      "Reklamační řád upravuje odpovědnost za vady prodaného zboží.",
      SELLER,
      "Záruka. U nového zboží platí zákonná odpovědnost za vady. Spotřebitel uplatní reklamaci u prodávajícího.",
      "Postup. Obraťte se na info@thecreaksofficial.com s popisem vady a číslem objednávky. Zboží zašlete zpět nebo ho přineste na výdejní místo.",
      "Vyřízení. Reklamaci vyřídíme bez zbytečného odkladu, nejpozději do 30 dnů.",
      "Výsledek. Podle povahy vady zboží vyměníme, opravíme, poskytneme slevu nebo vrátíme peníze.",
    ],
  },
  privacy: {
    title: "Ochrana osobních údajů (GDPR)",
    body: [
      "Zásady zpracování osobních údajů pro e-shop The Creaks.",
      SELLER,
      "Jaké údaje zpracováváme. Jméno, e-mail, telefon, doručovací adresu a údaje o objednávce a platbě.",
      "Proč. Abychom mohli vyřídit objednávku, doručit zboží a splnit zákonné povinnosti (účetnictví).",
      "Jak dlouho. Po dobu nezbytnou k vyřízení objednávky a dále po dobu stanovenou zákonem (zpravidla 5 let pro účetní doklady).",
      "Komu. Údaje předáváme dopravci (Zásilkovna) a platební bráně (SumUp) jen v rozsahu nutném pro doručení a platbu.",
      "Vaše práva. Máte právo na přístup, opravu, výmaz, omezení zpracování a přenositelnost údajů. Obraťte se na info@thecreaksofficial.com.",
    ],
  },
  withdrawal: {
    title: "Odstoupení od smlouvy",
    body: [
      "Spotřebitel má právo odstoupit od smlouvy do 14 dnů od převzetí zboží bez udání důvodu.",
      SELLER,
      "Oznámení. Zašlete e-mail na info@thecreaksofficial.com s číslem objednávky a prohlášením, že odstupujete od smlouvy.",
      "Vrácení zboží. Zboží zašlete zpět do 14 dnů od odstoupení, nepoškozené a pokud možno v původním obalu.",
      "Vrácení peněz. Peníze vrátíme do 14 dnů od doručení vašeho odstoupení stejným způsobem, jakým jste platili. Náklady na vrácení zboží nese spotřebitel.",
    ],
  },
};

export default function LegalPage({ kind }) {
  const page = PAGES[kind] || PAGES.terms;
  const links = [
    ["terms", "Obchodní podmínky"],
    ["returns", "Reklamační řád"],
    ["privacy", "Ochrana údajů"],
    ["withdrawal", "Odstoupení"],
  ];
  return (
    <div className="legal">
      <div className="legal-inner">
        <nav className="legal-nav">
          {links.map(([k, label]) => (
            <Link key={k} to={`/merch/${k}`} className={k === kind ? "on" : ""}>
              {label}
            </Link>
          ))}
        </nav>
        <h1>{page.title}</h1>
        {page.body.map((p, i) => (
          <p key={i}>{p}</p>
        ))}
        <p className="legal-note">Toto je vzorový text. Před spuštěním e-shopu ho zkontrolujte s účetním nebo právníkem.</p>
        <Link to="/merch" className="legal-back">
          Zpět do obchodu
        </Link>
      </div>
    </div>
  );
}
